import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody, CardHeader, Button, Row, Col } from 'reactstrap';
import { kebabCase } from 'lodash';
import SaveButton from '../controls/saveButton';
import Icon from './icon';
import ReportTagsButton from '../controls/reportTagsButton';
import FavoriteButton from '../../favorites/favoriteButton';
const SectionPanel = _ref => {
  let _ref$onNavButtonClick = _ref.onNavButtonClick,
    onNavButtonClick = _ref$onNavButtonClick === void 0 ? false : _ref$onNavButtonClick,
    _ref$navButtonTitle = _ref.navButtonTitle,
    navButtonTitle = _ref$navButtonTitle === void 0 ? '' : _ref$navButtonTitle,
    _ref$onBack = _ref.onBack,
    onBack = _ref$onBack === void 0 ? false : _ref$onBack,
    _ref$backButtonTitle = _ref.backButtonTitle,
    backButtonTitle = _ref$backButtonTitle === void 0 ? '' : _ref$backButtonTitle,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? [] : _ref$children,
    _ref$centerText = _ref.centerText,
    centerText = _ref$centerText === void 0 ? true : _ref$centerText,
    _ref$isSaveDisabled = _ref.isSaveDisabled,
    isSaveDisabled = _ref$isSaveDisabled === void 0 ? false : _ref$isSaveDisabled,
    _ref$isNavButtonVisib = _ref.isNavButtonVisible,
    isNavButtonVisible = _ref$isNavButtonVisib === void 0 ? true : _ref$isNavButtonVisib,
    _ref$isPending = _ref.isPending,
    isPending = _ref$isPending === void 0 ? false : _ref$isPending,
    _ref$showSave = _ref.showSave,
    showSave = _ref$showSave === void 0 ? true : _ref$showSave,
    _ref$showTagButton = _ref.showTagButton,
    showTagButton = _ref$showTagButton === void 0 ? false : _ref$showTagButton,
    _ref$showFavoriteButt = _ref.showFavoriteButton,
    showFavoriteButton = _ref$showFavoriteButt === void 0 ? false : _ref$showFavoriteButt,
    onSave = _ref.onSave;
  let saveState = SaveButton.STATUS_DISABLED;
  if (isPending && !isSaveDisabled) {
    saveState = SaveButton.STATUS_PENDING;
  } else if (isPending && isSaveDisabled) {
    saveState = SaveButton.STATUS_IN_PROGRESS;
  }
  const classes = classnames({
    'text-center': centerText
  });
  const bbTitle = backButtonTitle ? " ".concat(backButtonTitle) : 'Back';
  const backButtonGlyphs = bbTitle ? null : /*#__PURE__*/React.createElement(Icon, {
    glyph: "arrow-left"
  });
  const rightOptionalButtonCount = (showTagButton ? 1 : 0) + (showFavoriteButton ? 1 : 0);
  let titleColumnWidth = 8 - rightOptionalButtonCount;
  const rightButtonColumnWidth = 2 + rightOptionalButtonCount;
  let leftButtonColumnWidth = 2;
  if (onBack && onNavButtonClick && isNavButtonVisible) {
    titleColumnWidth -= 1;
    leftButtonColumnWidth = 3;
  }
  return /*#__PURE__*/React.createElement(Card, {
    className: "t-section-panel"
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: leftButtonColumnWidth
  }, onBack ? /*#__PURE__*/React.createElement(Button, {
    className: "float-md-left t-button-back",
    size: "sm",
    onClick: onBack
  }, backButtonGlyphs, bbTitle) : undefined, onNavButtonClick && isNavButtonVisible ? /*#__PURE__*/React.createElement(Button, {
    className: "t-button-nb",
    size: "sm",
    onClick: onNavButtonClick
  }, navButtonTitle) : undefined), /*#__PURE__*/React.createElement(Col, {
    sm: titleColumnWidth
  }, /*#__PURE__*/React.createElement("h3", {
    "data-testid": "t-sp-title",
    className: "t-sp-title t-sp-title-".concat(kebabCase(name))
  }, name)), /*#__PURE__*/React.createElement(Col, {
    sm: rightButtonColumnWidth
  }, showFavoriteButton ? /*#__PURE__*/React.createElement(FavoriteButton, null) : undefined, showTagButton ? /*#__PURE__*/React.createElement(ReportTagsButton, {
    reduxEntity: "report"
  }) : undefined, showSave ? /*#__PURE__*/React.createElement(SaveButton, {
    onSave: onSave,
    saveState: saveState
  }) : undefined)))), /*#__PURE__*/React.createElement(CardBody, null, children));
};
SectionPanel.propTypes = {
  centerText: PropTypes.bool,
  isPending: PropTypes.bool,
  isSaveDisabled: PropTypes.bool,
  isNavButtonVisible: PropTypes.bool,
  onNavButtonClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  navButtonTitle: PropTypes.string,
  onBack: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  backButtonTitle: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  showSave: PropTypes.bool,
  showTagButton: PropTypes.bool,
  showFavoriteButton: PropTypes.bool,
  name: PropTypes.string,
  children: PropTypes.node
};
export default SectionPanel;